export class PhotoSliderModule {
    initialize() {
        this.sliders = document.querySelectorAll('.photo-slider');
        this.sliders.forEach(slider => {
            new PhotoSlider().initialize(slider);
        });
    }
}   

class PhotoSlider {
    initialize(slider) {
        this.rootElement = slider;
        this.images = this.rootElement.querySelectorAll('.photo-slider-image');

        this.preview = this.rootElement.querySelector(".photo-slider-preview");
        this.previewImg = this.preview.querySelector(".photo-slider-preview-image");
        this.previewPrevButton = this.preview.querySelector(".photo-slider-preview-prev");
        this.previewNextButton = this.preview.querySelector(".photo-slider-preview-next");
        this.previewCloseButton = this.preview.querySelector(".photo-slider-preview-close");

        this.horizontalScrollContainer = this.rootElement.querySelector('.horizontal-scroll-container');
        this.horizontalScrollPrevButton = this.horizontalScrollContainer.querySelector('.horizontal-scroll-navigation-previous');
        this.horizontalScrollNextButton = this.horizontalScrollContainer.querySelector('.horizontal-scroll-navigation-next');

        // The minimal width for zooming is the breakpoint-md from Bootstrap
        const breakpointMd = getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-md');
        this.minimalWidthForZoom = Number(breakpointMd.replace('px', ''));

        this.activeImageIndex = -1; // not set

        this.setEventListeners();
    }

    setEventListeners() {
        this.images.forEach(image => {
            image.addEventListener('click', () => {
                this.onImageClick(image);
            });
        });

        this.previewPrevButton.addEventListener('click', () => {
            this.previousImage();
        });

        this.previewNextButton.addEventListener('click', () => {
            this.nextImage();
        });

        this.preview.addEventListener('click', (event) => {
            if (event.target === this.preview) {
                this.closePreview();
            }
        });

        this.previewCloseButton.addEventListener('click', () => {
            this.closePreview();
        });

        window.addEventListener('resize', () => {
            // Zoom has not a lot of function on mobile devices, because of the size
            if (window.innerWidth < this.minimalWidthForZoom) {
                this.closePreview();
            }
        });

        // Next/previous image when using arrow keys, close preview with escape
        document.addEventListener('keydown', (event) => {
            if (this.activeImageIndex === -1) return;

            if (event.key === "Escape") {
                this.closePreview();
            } else if (event.key === "ArrowLeft") {
                event.preventDefault();
                this.previousImage();
            } else if (event.key === "ArrowRight") {
                event.preventDefault();
                this.nextImage();
            }
        });
    }

    onImageClick(image) {
        this.activeImageIndex = parseInt(image.dataset.index);

        this.setHorizontalScrollPosition();
        this.renderButtons();

        this.previewImg.src = image.dataset.src;
        this.preview.classList.remove("hidden");
    }

    setHorizontalScrollPosition() {
        // Make sure the horizontal carousel is synced with the preview
        const maxInterval = this.images.length + 1;
        let interval = 0;

        while (this.horizontalScrollContainer.dataset.currentItem != this.activeImageIndex) {
            if (this.activeImageIndex < this.horizontalScrollContainer.dataset.currentItem) {
                this.horizontalScrollPrevButton.click();
            } else {
                this.horizontalScrollNextButton.click();
            }

            interval++;

            if (interval > maxInterval) {
                console.error("Could not set horizontal scroll position");
                break;
            }
        }
    }

    renderButtons() {
        // Hide buttons if first or last image

        if (this.activeImageIndex === 0) {
            this.previewPrevButton.classList.add("hidden");
        } else {
            this.previewPrevButton.classList.remove("hidden");
        }

        if (this.activeImageIndex === this.images.length - 1) {
            this.previewNextButton.classList.add("hidden");
        } else {
            this.previewNextButton.classList.remove("hidden");
        }
    }

    closePreview() {
        this.preview.classList.add("hidden");
        this.activeImageIndex = -1;
    }

    previousImage() {
        if (this.activeImageIndex < 1) return;

        const image = this.images[this.activeImageIndex - 1];
        if (image) this.onImageClick(image);
    }


    nextImage() {
        if (this.activeImageIndex >= this.images.length) return;

        const image = this.images[this.activeImageIndex + 1];
        if (image) this.onImageClick(image);
    }
}